export default __webpack_public_path__ + "static/media/Raleway-ExtraBold.ac7bcb8a.ttf";